var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("CustomerTargetExcelModal", {
        on: { success: _vm.successExcelImportCustomerTarget }
      }),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "CustomerTarget" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ErpCode",
                        error: _vm.$v.form.ErpCode
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.ErpCode
                        },
                        model: {
                          value: _vm.form.ErpCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ErpCode", $$v)
                          },
                          expression: "form.ErpCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "TciBreak1Id",
                        error: _vm.$v.form.TciBreak1Id
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.TciBreak1Id,
                          "lookup-key": "TCI_BREAKDOWN"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedType("TciBreak1Id", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ItemColumnName",
                        error: _vm.$v.form.ItemColumnName
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.ItemColumnName,
                          source: _vm.itemCriterias,
                          "dynamic-request": { paramId: "ITEM_CRITERIA" },
                          label: "Label"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectColumnName($event)
                          }
                        },
                        model: {
                          value: _vm.itemColumnName,
                          callback: function($$v) {
                            _vm.itemColumnName = $$v
                          },
                          expression: "itemColumnName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ItemColumnValue",
                        error: _vm.$v.form.ItemColumnValue
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.ItemColumnValue,
                          source: _vm.fieldValues,
                          label: "Label"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedType("ItemColumnValue", $event)
                          }
                        },
                        model: {
                          value: _vm.itemColumnValue,
                          callback: function($$v) {
                            _vm.itemColumnValue = $$v
                          },
                          expression: "itemColumnValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.CustomerTarget.CustomerTargetDetails")
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.CustomerId"),
                            error: _vm.$v.customerTargetDetails.customer,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              orConditionFields: "Code,Description1",
                              "dynamic-and-condition": { StatusIds: [1] },
                              label: "Description1",
                              searchable: true,
                              "custom-option": true,
                              "is-customer": true
                            },
                            model: {
                              value: _vm.customerTargetDetails.customer,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "customer",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.customer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.TargetQuantity"
                            ),
                            error: _vm.$v.customerTargetDetails.targetQuantity,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.targetQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "targetQuantity",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.targetQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.TargetUnitId"),
                            error: _vm.$v.customerTargetDetails.targetUnit,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              source: _vm.lookupValues,
                              label: "Label"
                            },
                            model: {
                              value: _vm.customerTargetDetails.targetUnit,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "targetUnit",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.targetUnit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.ReqItemId"),
                            error: _vm.$v.customerTargetDetails.reqItem,
                            required: !(
                              _vm.customerTargetDetails.customer &&
                              _vm.customerTargetDetails.targetQuantity &&
                              _vm.customerTargetDetails.gainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "dynamic-and-condition": { StatusIds: [1] },
                              url:
                                "/VisionNextItem/api/Item/AutocompleteSearch",
                              searchable: true,
                              source: _vm.items,
                              orConditionFields: "Code,Description1",
                              "custom-option": true
                            },
                            model: {
                              value: _vm.customerTargetDetails.reqItem,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "reqItem",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.reqItem"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.ReqItemQuantity"
                            ),
                            error: _vm.$v.customerTargetDetails.reqItemQuantity,
                            required: !(
                              _vm.customerTargetDetails.customer &&
                              _vm.customerTargetDetails.targetQuantity &&
                              _vm.customerTargetDetails.gainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.reqItemQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "reqItemQuantity",
                                  $$v
                                )
                              },
                              expression:
                                "customerTargetDetails.reqItemQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.DescriptionReqItem"
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value:
                                _vm.customerTargetDetails.descriptionReqItem,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "descriptionReqItem",
                                  $$v
                                )
                              },
                              expression:
                                "customerTargetDetails.descriptionReqItem"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.GainAmount"),
                            error: _vm.$v.customerTargetDetails.gainAmount,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.gainAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "gainAmount",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.gainAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.currencyId"),
                            error: _vm.$v.customerTargetDetails.currency,
                            required: !(
                              _vm.customerTargetDetails.customer &&
                              _vm.customerTargetDetails.targetQuantity &&
                              _vm.customerTargetDetails.gainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { disabled: true, source: _vm.currencies },
                            model: {
                              value: _vm.customerTargetDetails.currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "currency",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.currency"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addContractItems($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.customer-target-excel-modal",
                                      modifiers: {
                                        "customer-target-excel-modal": true
                                      }
                                    }
                                  ],
                                  staticClass: "mt-4",
                                  attrs: { size: "sm", variant: "success" }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-file-pdf" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "insert.creditBudget.uploadExcel"
                                        )
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.CustomerTarget.CustomerId")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.CustomerTarget.TargetQuantity"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.CustomerTarget.TargetUnitId"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.CustomerTarget.ReqItemId")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.CustomerTarget.ReqItemQuantity"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.CustomerTarget.DescriptionReqItem"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.CustomerTarget.GainAmount")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.CustomerTarget.currencyId")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(_vm.form.CustomerTarget, function(c, i) {
                              return _c(
                                "b-tr",
                                { key: i },
                                [
                                  _c("b-td", [
                                    _vm._v(
                                      _vm._s(
                                        c.CustomerName
                                          ? c.CustomerName
                                          : c.CustomerDesc
                                          ? c.CustomerDesc
                                          : c.CustomerCode
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(_vm._s(c.TargetQuantity))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(_vm._s(c.TargetUnitLabel))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(c.ReqItem))]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(_vm._s(c.ReqItemQuantity))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [
                                    _vm._v(_vm._s(c.DescriptionReqItem))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(c.GainAmount))]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(c.CurrencyName))]),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "btn mr-2 btn-warning btn-sm",
                                          on: {
                                            click: function($event) {
                                              return _vm.editInvoiceLine(c)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil-alt"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "btn mr-2 btn-danger btn-sm",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeContractItems(c)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-trash-alt"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.CustomerTarget.CustomerTargetDates")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.customerTargetDatesItems },
                    model: {
                      value: _vm.form.CustomerTargetDates,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerTargetDates", $$v)
                      },
                      expression: "form.CustomerTargetDates"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07803d76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07803d76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CustomerTarget/insert.vue
// module id = null
// module chunks = 